/**
 * Created by jonas on 2022-06-10.
 */
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {WinSize} from "../view/KitchenDramaSushiManiaWinView";
import {CustomEase} from "gsap/dist/CustomEase";
import {SymbolValues} from "../server/KitchenDramaSushiManiaData";

export class KitchenDramaSushiManiaStatics {


    public static isLowSymbol(value:string):boolean {
        return KitchenDramaSushiManiaStatics.LOW_SYMBOLS.indexOf(value) >= 0;
    }

    public static LOW_SYMBOLS:string[] = ["L1","L2","L3","L4"];
    public static MID_SYMBOLS:string[] = ["M1","M2","M3","M4"];
    public static HIG_SYMBOLS:string[] = ["W", "W2"];

    public static SYMBOL_HEIGHT:number = 164;//130;
    public static SYMBOL_WIDTH:number = 142;//118;

    public static REEL_X_OFFSET:number = 5;
    public static REEL_Y_OFFSET:number = 90;

    public static TIME_SCALE = 1.5;


    //public static countEase = CustomEase.create("custom", "M0,0 C0.728,0.728 0.694,1 1,1 ");
    public static WHIP_EASE = CustomEase.create("whip", "M0,0 C0,0 0.258,-0.229 0.444,-0.044 0.629,0.141 0.751,0.813 0.854,1.05 0.911,1.182 1,1 1,1");

    public static defaultSymbolValues:SymbolValues = {
        "M1": {
            "3": 10,
            "4": 50,
            "5": 500
        },
        "M2": {
            "3": 9,
            "4": 40,
            "5": 300
        },
        "L1": {
            "3": 5,
            "4": 20,
            "5": 75
        },
        "M3": {
            "3": 8,
            "4": 35,
            "5": 200
        },
        "L2": {
            "3": 5,
            "4": 20,
            "5": 75
        },
        "M4": {
            "3": 7,
            "4": 30,
            "5": 100
        },
        "L3": {
            "3": 4,
            "4": 15,
            "5": 50
        },
        "W": {
            "3": 10,
            "4": 50,
            "5": 500
        },
        "L4": {
            "3": 4,
            "4": 15,
            "5": 50
        },
        "W2": {
            "3": 10,
            "4": 50,
            "5": 500
        }
    };


    constructor() {

    }

    static getWinType(avalancheWin:number):WinSize {
        const ratio = avalancheWin / KitchenDramaSushiMania.model.gameData.playedBetValue;
        return KitchenDramaSushiManiaStatics.getWinTypeFromRatio(ratio);
    }

    static getWinTypeFromRatio(winRatio:number):WinSize {

        if(winRatio <= 1) {
            return WinSize.tiny;
        }
        //small
        if(winRatio <= 3) {
            return  WinSize.small;
        }
        //Medium
        if(winRatio <= 5) {
            return  WinSize.medium;
        }
        //Large
        if(winRatio < 15) {
            return WinSize.large;
        }

        if(winRatio <= 25) {
            return  WinSize.big;
        }

        if(winRatio <= 50) {
            return  WinSize.mega;
        }

        if(winRatio > 50) {
            return  WinSize.superMega;
        }
        return  WinSize.none;
    }

}